import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";

const LOGO_URL = "/images/logo-isiap.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    soluzioni: [
      { label: "Ristorazione", path: "/soluzioni#ristorazione" },
      { label: "Retail", path: "/soluzioni#retail" },
      { label: "Prenotazioni", path: "/soluzioni#prenotazioni" },
      { label: "Magazzino", path: "/soluzioni#magazzino" },
    ],
    azienda: [
      { label: "Chi Siamo", path: "/chi-siamo" },
      { label: "FAQ", path: "/faq" },
      { label: "Contatti", path: "/contatti" },
    ],
  };

  return (
    <footer className="bg-[#1a1f36] text-white" data-testid="footer">
      <div className="section-container">
        {/* Main footer */}
        <div className="py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <img 
                src={LOGO_URL} 
                alt="iSiAP" 
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-[#9ca3af] text-sm leading-relaxed mb-6">
              Semplifica la gestione della tua attività con un'unica piattaforma 
              digitale per vendite, magazzino e documenti fiscali.
            </p>
            <div className="flex flex-col gap-3">
              <a 
                href="mailto:info@isiap.it" 
                className="flex items-center gap-3 text-[#9ca3af] hover:text-[#FF6B00] transition-colors text-sm"
                data-testid="footer-email"
              >
                <Mail size={16} className="text-[#FF6B00]" />
                info@isiap.it
              </a>
              <a 
                href="tel:0383644311" 
                className="flex items-center gap-3 text-[#9ca3af] hover:text-[#FF6B00] transition-colors text-sm"
                data-testid="footer-phone"
              >
                <Phone size={16} className="text-[#FF6B00]" />
                0383 644311
              </a>
              <a 
                href="tel:3517521168" 
                className="flex items-center gap-3 text-[#9ca3af] hover:text-[#FF6B00] transition-colors text-sm"
                data-testid="footer-mobile"
              >
                <Phone size={16} className="text-[#FF6B00]" />
                351 752 1168
              </a>
            </div>
          </div>

          {/* Solutions column */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-6 text-[#FF6B00]">
              Soluzioni
            </h4>
            <ul className="space-y-3">
              {footerLinks.soluzioni.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-[#9ca3af] hover:text-white transition-colors text-sm flex items-center gap-1 group"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                    <ArrowUpRight 
                      size={12} 
                      className="opacity-0 group-hover:opacity-100 transition-opacity text-[#FF6B00]" 
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-6 text-[#FF6B00]">
              Azienda
            </h4>
            <ul className="space-y-3">
              {footerLinks.azienda.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-[#9ca3af] hover:text-white transition-colors text-sm flex items-center gap-1 group"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(" ", "-")}`}
                  >
                    {link.label}
                    <ArrowUpRight 
                      size={12} 
                      className="opacity-0 group-hover:opacity-100 transition-opacity text-[#FF6B00]" 
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA column */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-6 text-[#FF6B00]">
              Inizia Ora
            </h4>
            <p className="text-[#9ca3af] text-sm mb-6">
              Scopri come iSiAP può trasformare la gestione della tua attività.
            </p>
            <Link
              to="/prenota"
              className="inline-flex items-center gap-2 bg-[#FF6B00] text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#E55F00] transition-colors"
              data-testid="footer-cta"
            >
              Richiedi una Demo
              <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-[#2d3452] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#7a7f94] text-sm text-center md:text-left">
            © {currentYear} 4D Sistemi Informatici. iSiAP è un prodotto 4D Sistemi Informatici. 
            Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-6 text-sm text-[#7a7f94]">
            <Link to="/privacy" className="hover:text-[#FF6B00] transition-colors">
              Privacy
            </Link>
            <Link to="/termini" className="hover:text-[#FF6B00] transition-colors">
              Termini
            </Link>
            <Link to="/faq" className="hover:text-[#FF6B00] transition-colors">
              FAQ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
